import Vue from "vue";
import Vuex from "vuex";
import account from "./modules/account";
import stakingPools from "./modules/stakingPools";
// import steamStakingPools from "./modules/steamStakingPools";
import deposit from "./modules/deposit";
import withdraw from "./modules/withdraw";
import harvest from "./modules/withdraw";
import toast from "./modules/toast";
import cakeLpFarmings from "./modules/cakeLpFarmings";
// import steamCakeLpFarmings from "./modules/steamCakeLpFarmings";
// import limitedSaunaCakeLpFarmings from "./modules/limitedSaunaCakeLpFarmings";
// import limitedSaunaStakingPools from "./modules/limitedSaunaStakingPools";
// import boilerRoom from "./modules/boilerRoom";
// import boilerToken from "./modules/boilerToken";
import message from "./modules/message";
// import limitedBoilerCakeLpFarmings from "./modules/limitedBoilerCakeLpFarmings";
// import boilerCakeLpFarmings from "./modules/boilerCakeLpFarmings";
import web3 from "./modules/web3";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    web3,
    account,
    stakingPools,
    deposit,
    withdraw,
    harvest,
    toast,
    cakeLpFarmings,
    // steamStakingPools,
    // steamCakeLpFarmings,
    // limitedSaunaCakeLpFarmings,
    // limitedSaunaStakingPools,
    // boilerRoom,
    // boilerToken,
    message,
    // limitedBoilerCakeLpFarmings,
    // boilerCakeLpFarmings,
  },
  state: {
    isLogin: sessionStorage.getItem("address") ? true : false,
    theme: "light",
    modal: {
      isShow: false,
      target: "",
    },
  },
  actions: {
    onLogin({ commit }) {
      commit("onLogin");
    },
    onLogout({ commit }) {
      commit("onLogout");
      commit("closeModal");
    },
    openModal({ commit }, target) {
      commit("openModal", { target: target });
    },
    closeModal({ commit }) {
      commit("closeModal");
    },
    changeTheme({ commit }, theme) {
      commit("changeTheme", { theme: theme });
    },
  },
  mutations: {
    onLogin(state) {
      state.isLogin = true;
    },
    onLogout() {
      localStorage.removeItem("walletconnect");
      sessionStorage.removeItem("address");
      sessionStorage.removeItem("provider");
      window.location.reload();
    },
    openModal(state, { target }) {
      state.modal.isShow = true;
      state.modal.target = target;
    },
    closeModal(state) {
      state.modal.isShow = false;
      state.modal.target = "";
    },
    changeTheme(state, { theme }) {
      state.theme = theme;
    },
  },
});

export default store;
